import transformers from "./transformers";

const mockContext = require.context("./mock", true, /.*\.json$/);
const gqlContext = require.context("./gql", true, /.*\.js$/);

export default class Unified {
  constructor({ multiServiceTypeFactory }) {
    this.graphql = multiServiceTypeFactory(
      mockContext,
      gqlContext,
      "Unified"
    ).graphql;
  }

  async getCustomerName() {
    return transformers.toUIData.customerName(
      await this.graphql.callGql("GetCustomerName")
    );
  }

  async getUserProfile() {
    return transformers.toUIData.userProfile(
      await this.graphql.callGql("GetUserProfile")
    );
  }

  async getBankList() {
    return transformers.toUIData.bankList(
      await this.graphql.callGql("GetBankList")
    );
  }

  async getStateList() {
    return transformers.toUIData.stateList(
      await this.graphql.callGql("StatesInfo")
    );
  }

  async deleteBank(bankData) {
    await this.graphql.callGql({
      gql: "DeleteBank",
      variables: transformers.toServicePayload.deleteBank(bankData),
    });
  }

  async addBank(bankData) {
    await this.graphql
      .callGql({
        gql: "AddBank",
        variables: transformers.toServicePayload.addBank(bankData),
      })
      .catch((error) => {
        throw transformers.toUIData.addBankError(error);
      });
  }

  async getCommPrefCustomer() {}

  async getAddressList() {}

  async getPhoneList() {}

  async addPhoneNumber() {}

  async addContact() {}

  async deletePhoneNumber() {}

  async deleteContact() {}

  async getCommPrefCustomer() {
    ///getCommPrefCustomer and getCommPrefTRACCustomer having same property...so written single function
  }

  async getOperatorUserProfileForRetail() {
    //getUserProfile having same property
  }

  async resendCode() {}

  async sendCode() {}

  async updateAccAddress() {}

  async updateCiamProfile() {}

  async updateTACommPrefCustomer() {}

  async updateTRACCommPrefCustomer() {}

  async updatePhoneNumber() {}

  async verifyMailingAddress() {}

  async verifyResidentialAddress() {}
}
